/**
 * Site header
 */

 let openNavButton = $('.js-nav-assets-menu-button');
 let closeNavButton = $('.js-nav-assets-close-menu-button');
 let overlayNav = $('.js-overlay');
 let wrapperNav = $('.js-nav-assets-nav-wrapper');
 let linkDropdownsNav = $('.js-nav-link-dropdown');
 
 function openNav() {
     openNavButton.attr('aria-expanded', 'true')
     closeNavButton.attr('aria-expanded', 'true')
     wrapperNav.addClass('is-active');
     overlayNav.addClass('is-active');
     trapFocus(wrapperNav);
 }
 
 function closeNav() {
     openNavButton.attr('aria-expanded', 'false')
     closeNavButton.attr('aria-expanded', 'false')
     wrapperNav.removeClass('is-active');
     overlayNav.removeClass('is-active');
     unTrapFocus(openNavButton);
 }
 function toggleSublistNav(e) {
     e.preventDefault();
     if (!$(this).hasClass('is-active')) {
         linkDropdownsNav.removeClass('is-active');
         linkDropdownsNav.attr('aria-expanded', 'true')
         $('.js-nav-assets-nav-sublist').slideUp();
         $(this).addClass('is-active').next('.js-nav-assets-nav-sublist').stop(true, true).slideDown();
         trapFocus($(this).next('.js-nav-assets-nav-sublist'));
     } else {
         $(this).attr('aria-expanded', 'false')
         $(this).removeClass('is-active').next('.js-nav-assets-nav-sublist').stop(true, true).slideUp();
         unTrapFocus($(this).prev('.js-nav-link-dropdown'));
     }
 }
 
 function closeAllSublitsNav() {
     linkDropdownsNav.removeClass('is-active');
     linkDropdownsNav.removeClass('is-active');
     $('.js-nav-assets-nav-sublist').filter(':visible').stop(true, true).slideUp().prev('.js-nav-link-dropdown').focus();
 }
 
 openNavButton.on('click', openNav);
 
 closeNavButton.on('click', closeNav);
 
 linkDropdownsNav.on('click', toggleSublistNav);
 
 $(document).on('keydown', function (e) {
     if (e.key == 'Escape') { 
         if (linkDropdownsNav.hasClass('is-active')) {
             closeAllSublitsNav();
         } else if (wrapperNav.hasClass('is-active')) {
             closeNav();
         }
     }
 });
 
 $(document).on('click', function (e) {
     let $target = $(e.target);
     if (!$target.closest('.c-nav-assets').length && navWrapper.hasClass('is-active') || $target.is(overlayNav)) {
         closeNav();
     } else if (!$target.closest('.c-nav-assets-nav__list').length && linkDropdownsNav.hasClass('is-active')) {
         closeAllSublitsNav();
     }
 });